<template>
    <div>
      <div class="flex">
          
      </div>
      <div>
        <div class="flex code-header px-4 py-2 text-gray-400 text-sm tracking-wide">
          <div class="flex-1 ">
            Request Code
          </div>
          <div>
            <select class="bg-transparent outline-none border-none" v-model="type">
              <option value="curl">cURL</option>
              <option value="node">Node.js</option>
              <option value="go">Go</option>
            </select>
          </div>
        </div>
        <highlightjs :language='lang' :code="fixedCode" />
      </div>
    </div>
  </template>
  
  <script>
  // import 'highlight.js/lib/common';
  // import hljsVuePlugin from "@highlightjs/vue-plugin";
  
  export default {
    name: "RequestCode",
    data: () => {
      return {
        type: "curl"
      }
    },
    props: ["request"],
    mounted () {
      
    },
    computed: {
      lang() {
        if (this.type === "node") {
          return "node"
        }

        if (this.type === "go") {
          return "go"
        }

        return "html"
      },
        fixedCode () {
          if (this.type === "curl") {
            return this.curl(this.request)
          }

          if (this.type === "node") {
            return this.node(this.request)
          }

          if (this.type === "go") { 
            return this.go(this.request)
          }

          return ""
        }
    },
    methods: {
      curl () { 
        if (this.request.request.method === "POST") {
          return `curl '${this.request.request.url}' \\
  -d '${JSON.stringify(this.request.request.body)}' \\
${Object.keys(this.request.request.headers  || {}).map((k, i) => {
  if (i + 1 === Object.keys(this.request.request.headers).length) {
    return `  -H '${k}: ${this.request.request.headers[k]}'`
  }
  return `  -H '${k}: ${this.request.request.headers[k]}' \\
`
}).join("")}`
        }

        return `curl '${this.request.request.url}' \\
${Object.keys(this.request.request.headers  || {}).map((k, i) => {
  if (i + 1 === Object.keys(this.request.request.headers).length) {
    return `  -H '${k}: ${this.request.request.headers[k]}'`
  }
  return `  -H '${k}: ${this.request.request.headers[k]}' \\
`
}).join("")}`
      },








    node () {
      if (this.request.request.method === "POST") {
        return `fetch("${this.request.request.url}", {
  headers: {
${Object.keys(this.request.request.headers  || {}).map((k, i) => {
  if (i + 1 === Object.keys(this.request.request.headers).length) {
    return `    "${k}": "${this.request.request.headers[k]}"`
  }
  return `    "${k}": "${this.request.request.headers[k]}",\n`
}).join("")}
  },
  method: "POST",
  body: JSON.stringify(${JSON.stringify(this.request.request.body || {}, null, 2).split("\n").join("\n   ")})
})`
      }


      return `fetch("${this.request.request.url}", {
  headers: {
${Object.keys(this.request.request.headers  || {}).map((k, i) => {
  if (i + 1 === Object.keys(this.request.request.headers).length) {
    return `    "${k}": "${this.request.request.headers[k]}"`
  }
  return `    "${k}": "${this.request.request.headers[k]}",\n`
}).join("")}
  },
  method: "GET"
})`
    },











      go () {
        if (this.request.request.method === "POST") {
          return `client := &http.Client{}
reqBody := \`${JSON.stringify(this.request.request.body)}\`
req, _ := http.NewRequest("POST", "${this.request.request.url}", bytes.NewBuffer(reqBody))

${Object.keys(this.request.request.headers  || {}).map((k) => {
  return `req.Header.Set("${k}", "${this.request.request.headers[k]}")
`
}).join("")}
res, err := client.Do(req); if err != nil {
  panic(err)
}

defer res.Body.Close()

body, err := io.ReadAll(res.Body); if err != nil {
    panic(err)
}

fmt.Println(string(body))`

        }

        return `client := &http.Client{}
req, _ := http.NewRequest("GET", "${this.request.request.url}", nil)

${Object.keys(this.request.request.headers  || {}).map((k) => {
  return `req.Header.Set("${k}", "${this.request.request.headers[k]}")
`
}).join("")}
res, err := client.Do(req); if err != nil {
  panic(err)
}

defer res.Body.Close()

body, err := io.ReadAll(res.Body); if err != nil {
    panic(err)
}

fmt.Println(string(body))`
      }
    },
    components: {
        // highlightjs: hljsVuePlugin.component
    }
    
  }
  </script>
  

